import ConfigurationManager, { realmType } from './configurationManager';

export default async function generateAuthURL(realm?: realmType) {
    const { AUTH_URL, CLIENT_ID, REDIRECT_URI, RESPONSE_TYPE } =
        await ConfigurationManager.getInstance().getConfigFile(realm);

    const url = new URL(AUTH_URL);
    url.searchParams.set('client_id', CLIENT_ID);
    url.searchParams.set('redirect_uri', REDIRECT_URI);
    url.searchParams.set('response_type', RESPONSE_TYPE);

    return url.toString();
}
